module.exports = __webpack_public_path__ + "img/slide-18-5.88976ef6.jpg";